import React from 'react';

const HomeProc2 = props => {
  return (
    <div>

    </div>
  )
}

export default HomeProc2